/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';
/**
 * Then we wrap useCallback so it can be used as a prop for a component
 */
export const useFlatListRenderItem = (callback, deps) => useCallback(callback, deps);
export const useSectionListRenderItem = (callback, deps) => useCallback(callback, deps);
